import { useCallback, useState } from 'react';

const usePopup = () => {
  const [isOpenPopup, setOpenPopup] = useState(false);

  const togglePopup = useCallback(() => {
    setOpenPopup(isOpen => !isOpen);
  }, [setOpenPopup]);

  return {
    isOpenPopup,
    setOpenPopup,
    togglePopup,
  };
};

export default usePopup;
